import YesNoQuestionPage from "@components/YesNoQuestionPage"

export default function HomeExperimentingPage() {
  return <YesNoQuestionPage translationKey="homeExperimenting" />
}
